/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Transaction } from "./Transaction";
import * as t from "io-ts";

// required attributes
const TransactionListResponseR = t.interface({});

// optional attributes
const TransactionListResponseO = t.partial({
  data: t.readonlyArray(Transaction, "array of Transaction"),

  size: t.Integer,

  start: t.Integer,

  total: t.Integer
});

export const TransactionListResponse = t.intersection(
  [TransactionListResponseR, TransactionListResponseO],
  "TransactionListResponse"
);

export type TransactionListResponse = t.TypeOf<typeof TransactionListResponse>;
